import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckCircleIcon } from '@yonderland/andes-icons';
import { Stack, useMediaQueryMatchesOnMobile, Button, TextAlpha, Icon } from '@yonderland/andes-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { ETICKET_CONSTANTS } from '../../../containers/EticketContainer';
export const EticketRatingButtons = ({ rateItem, rating }) => {
    const { t } = useTranslation(I18N_NAMESPACES.general);
    const isMobile = useMediaQueryMatchesOnMobile();
    const [voted, setVoted] = useState();
    const rateDivision = (rate) => {
        rateItem(rate);
        setVoted(rate);
    };
    const getButtonTheme = (ratingValue) => (rating === ratingValue && !voted ? 'branded' : 'neutral');
    const ETICKET_BUTTONS = [
        {
            ratingValue: ETICKET_CONSTANTS.RATING.GOOD,
            text: t('eticket.rating.good'),
        },
        {
            ratingValue: ETICKET_CONSTANTS.RATING.OK,
            text: t('eticket.rating.okay'),
        },
        {
            ratingValue: ETICKET_CONSTANTS.RATING.BAD,
            text: t('eticket.rating.bad'),
        },
    ];
    return (_jsx(Stack, { gap: "5", direction: isMobile ? 'col' : 'row', children: ETICKET_BUTTONS.map(({ ratingValue, text }) => (_jsxs(Stack, { direction: "col", gap: "1", children: [_jsx(Button, { onClick: () => rateDivision(ratingValue), theme: getButtonTheme(ratingValue), state: voted ? 'disabled' : undefined, children: text }), voted === ratingValue && (_jsxs(Stack, { gap: "1", align: "center", children: [_jsx(Icon, { source: CheckCircleIcon, size: "sm", color: "success" }), _jsx(TextAlpha, { color: "success", children: text })] }))] }, ratingValue))) }));
};
